import React from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";

import SafraTheme from "./styles/theme";
import GlobalStyles from "./styles/globalStyles";

import RouteApp from "./router/Router";
import { MessageBoxProvider } from "context/MessageBoxContext";
import { FilterDataProvider } from "context/FilterDataContext";

const container = document.getElementById("app");

const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <MantineProvider withNormalizeCSS withGlobalStyles theme={SafraTheme}>
    <GlobalStyles />
    <MessageBoxProvider>
      <FilterDataProvider>
        <RouteApp />
      </FilterDataProvider>
    </MessageBoxProvider>
  </MantineProvider>
  // </React.StrictMode>
);
